<header class="sticky top-0 z-50 flex h-14 items-center border-b-2 border-slate-200 bg-white px-4 shadow-sm">
  <div class="grid w-full grid-cols-[1fr_auto_1fr] items-center gap-4">
    <!-- Logo: logo replaces U, p stays, together as "Up" -->
    <a routerLink="/" class="font-display flex items-center gap-0 text-xl font-bold tracking-tight" aria-label="Home">
      <img src="favicon.png" alt="U" class="h-7 w-7 shrink-0 object-contain" />
      <span class="text-slate-800">p</span>
      <span class="text-blue-600">TCF</span>
    </a>

    <!-- Center nav: Home, Writing -->
    <nav class="flex items-center justify-center gap-1">
      <a routerLink="/" routerLinkActive="!bg-slate-100 !text-blue-600"
        class="flex items-center gap-2 rounded-lg px-3 py-2 text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
        [routerLinkActiveOptions]="{ exact: true }">
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
        </svg>
        <span>主页</span>
      </a>

      <a routerLink="/writing" routerLinkActive="!bg-slate-100 !text-blue-600"
        class="flex items-center gap-2 rounded-lg px-3 py-2 text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900">
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" />
        </svg>
        <span>写作</span>
      </a>
    </nav>

    <!-- Right nav: User profile -->
    <div class="relative flex justify-end">
      @if (auth.isAuthenticated()) {
      <div class="flex items-center justify-end gap-3">
        @if (examCountdown(); as countdown) {
        <span [attr.title]="'Exam: ' + countdown.examDateFormatted"
          class="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1.5 text-sm font-medium text-emerald-800">
          <svg class="h-4 w-4 text-emerald-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
          </svg>
          @if (countdown.isToday) {
          <span class="animate-pulse font-semibold">Today's the day!</span>
          } @else if (countdown.isPast) {
          <span class="font-semibold">You did it!</span>
          } @else {
          <span>距离考试</span>
          <span class="tabular-nums font-bold">{{ countdown.days }}</span>
          <span>天</span>
          }
        </span>
        }
        <div #userMenu class="relative">
          <button type="button"
            class="flex items-center gap-2 rounded-lg px-3 py-2 text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
            (click)="toggleUserMenu()" aria-label="User menu">
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
            </svg>
            <span>{{ userDisplayLabel() }}</span>
            <svg class="h-4 w-4 transition-transform" [class.rotate-180]="userMenuOpen()"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
          @if (userMenuOpen()) {
          <div
            class="absolute right-0 top-full z-10 mt-1 min-w-[12rem] rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
            <a routerLink="/profile" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
              (click)="userMenuOpen.set(false)">
              My profile
            </a>
            @if (isAdmin()) {
            <a routerLink="/admin" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
              (click)="userMenuOpen.set(false)">
              Admin
            </a>
            }
            <button type="button" class="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
              (click)="signOut()">
              Sign out
            </button>
          </div>
          }
        </div>
      </div>
      } @else {
      <button type="button"
        class="flex items-center gap-2 rounded-lg px-3 py-2 text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
        (click)="openAuthDialog()" aria-label="Sign in or register">
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
        </svg>
        <span>Sign in</span>
      </button>
      }
    </div>
  </div>

  <app-auth-dialog [visible]="authDialogVisible()" [view]="authView()"
    (visibleChange)="onAuthDialogVisibleChange($event)" (viewChange)="onAuthViewChange($event)"
    (success)="onAuthSuccess()" />
</header>